import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { UwTableColumn } from './table-column.model';
import { MatFormField, MatLabel } from '@angular/material/input';
import { MatSelect, MatSelectTrigger } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'uw-table-column-management',
    templateUrl: './table-column-management.component.html',
    styleUrls: ['./table-column-management.component.scss'],
    imports: [MatFormField, MatLabel, MatSelect, ReactiveFormsModule, MatSelectTrigger, MatOption, TranslateModule]
})
export class TableColumnManagementComponent implements OnInit, OnChanges {
 
  @Input()
  allColumns!: UwTableColumn[];
  
  @Input()
  class!: string;

  @Output()
  columnsChange = new EventEmitter<string[]>();

  @Input()
  displayedColumnIds!: string[];

  readonly SELECT_ALL_VALUE = '-1';

  columnsControl = new FormControl<string[] | null>(null);

  allColumnIds!: string[];

  ngOnInit(): void {
    this.columnsControl.valueChanges.subscribe((value) =>
      {
        if(value?.includes(this.SELECT_ALL_VALUE)) {

          if (value.length != this.allColumnIds.length) {
            this.columnsChange.emit(this.allColumnIds);
          } else {
            const index = value.indexOf(this.SELECT_ALL_VALUE);
            if (index !== -1) {
              value.splice(index, 1);
              this.columnsChange.emit(value);
            }
          }
          
          return;
        }

        this.columnsChange.emit(value!)
      }
      
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes &&
      changes.displayedColumnIds &&
      changes.displayedColumnIds.currentValue
    ) {
      this.columnsControl.setValue(this.displayedColumnIds);
    }

    if (changes && changes.allColumns && changes.allColumns.currentValue) {
      this.allColumnIds = this.allColumns.map((column) => column.id);
    }

    if (this.displayedColumnIds && this.allColumnIds && this.displayedColumnIds.length == this.allColumnIds.length) {
      this.columnsControl.setValue([...this.displayedColumnIds, '-1']);
    }
  }

  getItemName(itemId: string) {
    const item = this.allColumns?.find(items => items.id == itemId);
    return item?.name;
  }

  // clearSelection(select: any): void {
  //   this.columnsControl.setValue(this.displayedColumnIds);
  //   select.close();
  // }
}
